import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Image, message, Upload } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { EmptyData, PageLoading, SplitPane } from "../../components";
import plus from "../../assets/svg/plus.svg";
import MainLayout from "../../components/MainLayout/MainLayout";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { hideScrollbar, LandingTitle } from "../../lib/styles/styleLibrary";
// import { photos } from "../../settings/paths";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { uploadWeddingPhotos } from "../../redux/actions/media";
import { useMutation } from "react-query";
import {
	ImageMansoryWrapper,
	PhotoWrapper,
	UploadImageWrapper,
} from "./component";
import { useCouplesData } from "../../redux/api/WeddingAPI";
import { v4 } from "uuid";

const OurPhotos = (props) => {
	const history = useHistory();
	const { data: coupleData, refetch, isLoading } = useCouplesData();

	const couple = coupleData?.data;
	const albumId = !isEmpty(couple?.wedding_albums)
		? couple?.wedding_albums[0].id
		: null;
	const weddingId = couple?.id;
	const weddingPhotos = couple?.wedding_media;
	const photos = [];
	console.log(couple);
	const { mutateAsync: handleUpload, isLoading: uploading } =
		useMutation(uploadWeddingPhotos);

	const ImageMansory = () => {
		const [currentImage, setCurrentImage] = useState(0);
		const [viewerIsOpen, setViewerIsOpen] = useState(false);

		useEffect(() => {
			weddingPhotos?.forEach((i) => {
				weddingPhotos.length === 1
					? photos.push({
							src: i.media_url,
							src_min: i.media_url_min,
							width: 4,
							height: 3,
					  })
					: photos.push({
							src: i.media_url,
							src_min: i.media_url_min,
							width: Math.floor(Math.random() * 3) + 4,
							height: Math.floor(Math.random() * 2) + 2,
					  });
			});
			// eslint-disable-next-line
		}, [weddingPhotos]);

		const openLightbox = useCallback((event, { photo, index }) => {
			setCurrentImage(index);
			setViewerIsOpen(true);
		}, []);

		const closeLightbox = () => {
			setCurrentImage(0);
			setViewerIsOpen(false);
		};
		return (
			<ImageMansoryWrapper>
				{isLoading ? (
					<PageLoading />
				) : (
					isEmpty(weddingPhotos) && (
						<div tw="h-full w-full flex items-center justify-center">
							<EmptyData />
						</div>
					)
				)}
				<Gallery photos={photos} onClick={openLightbox} />
				<ModalGateway>
					{viewerIsOpen ? (
						<Modal onClose={closeLightbox}>
							<Carousel
								currentIndex={currentImage}
								views={photos.map((x) => ({
									...x,
									srcset: x.srcSet,
									caption: x.title,
								}))}
							/>
						</Modal>
					) : null}
				</ModalGateway>
				{/* </>
				)} */}
			</ImageMansoryWrapper>
		);
	};

	const UploadImage = () => {
		// Upload photo album content

		const [storyFileList, setStoryFileList] = useState([]);
		const [showStoryupload, setShowStoryUpload] = useState(true);

		const handleBeforeUpload = (file) => {
			// Processing file Change, guaranteed that the user selected by one is only one
			setStoryFileList([...storyFileList, file]);
			return true;
		};

		const handleStoryFileChange = ({ fileList }) => {
			setStoryFileList([...fileList]);
		};

		console.log(storyFileList, weddingId);

		const handleStoryMediaUpload = async (options) => {
			if (isEmpty(storyFileList)) {
				return message.warning(
					"Please select the file you want to upload"
				);
			}
			if (isEmpty(weddingId)) {
				return Toast.fire({
					icon: "error",
					title: "Cant upload photo,\nWedding data not found",
				});
			}
			const formData = new FormData();
			formData.append("uuid", v4());
			storyFileList.forEach((file) => {
				formData.append(`media`, file);
			});

			const weddingData = { weddingId, albumId };
			const credentials = { formData, weddingData };
			try {
				const response = await handleUpload(credentials);
				console.log(
					"\nupload photo media res: =====>\n",
					response.data
				);
				const { hasError } = response.data;
				if (hasError) {
					return Toast.fire({
						icon: "error",
						title: response.data.message,
					});
				}
				Toast.fire({
					icon: "success",
					title: response.data.message,
				});
				const { media_records } = response.data.data;
				console.log(media_records);
				setStoryFileList([]);
				setShowStoryUpload(false);
			} catch (err) {
				console.log("Error: ", err);
			} finally {
				refetch();
			}
		};
		// Remove Image from array
		const handleRemove = (selectedFile) => {
			return storyFileList.filter((file) => {
				return selectedFile.uid !== file.uid;
			});
		};

		return (
			<UploadImageWrapper>
				<div>
					<Upload
						defaultFileList={storyFileList}
						accept="image/*"
						onChange={handleStoryFileChange}
						onRemove={handleRemove}
						action={handleStoryMediaUpload}
						beforeUpload={handleBeforeUpload}
						listType="picture"
						multiple
						showUploadList={showStoryupload}>
						{storyFileList.length >= 10 ? null : (
							<Button
								size="large"
								className="btnStyle"
								tw="w-full h-full flex px-1.5 py-2 lg:px-6 lg:py-12 bg-white rounded flex-row-reverse  lg:flex-col flex-nowrap items-center justify-center gap-2">
								<Image
									preview={false}
									src={plus}
									alt=""
									width={25}
									height={25}
								/>
								<span tw="opacity-60 text-xs lg:text-base">
									Upload image
								</span>
							</Button>
						)}
					</Upload>
				</div>
			</UploadImageWrapper>
		);
	};

	return (
		<MainLayout>
			{uploading && <PageLoading />}

			<PhotoWrapper css={hideScrollbar}>
				{/* Photo Section */}
				<div
					tw="inline-flex flex-nowrap items-center gap-2 hover:cursor-pointer mb-4"
					onClick={() => {
						history.goBack();
					}}>
					<ArrowLeftOutlined tw="px-3 py-3 bg-gray-100 rounded-full hover:bg-white" />
					<LandingTitle tw="text-2xl font-bold leading-8 m-0">
						Our photos
					</LandingTitle>
				</div>

				<SplitPane
					wrapDirection={"column-reverse"}
					left={<ImageMansory />}
					right={<UploadImage />}
				/>
			</PhotoWrapper>
		</MainLayout>
	);
};

export default OurPhotos;
